/**
 * Silences console output in production builds.
 *
 * Imported for its side effect (first thing in `index.js`) so the no-ops are
 * installed before any other module runs.
 */
const noop = (): void => {};

if (process.env.NODE_ENV === "production") {
  console.log = noop;
  console.error = noop;
  console.warn = noop;
  console.info = noop;
}

export {};
